import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Resident } from '../../../models/resident.model';
import { ModalCloseButtonComponent } from '../../modal-close-button/modal-close-button.component';
import { MatIconModule } from '@angular/material/icon';
import { CreateNoteModalComponent } from '../create-note-modal/create-note-modal.component';
import { PermissionsService } from '../../../../core/services/permissions/permissions.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-resident-note-modal',
  templateUrl: './resident-note-modal.component.html',
  styleUrls: ['./resident-note-modal.component.scss'],
  imports: [ModalCloseButtonComponent, MatIconModule, CommonModule],
})
export class ResidentNoteModalComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { resident: Resident },
    private dialogRef: MatDialogRef<ResidentNoteModalComponent>,
    private dialog: MatDialog,
    public permissionsService: PermissionsService
  ) {}

  closeDialog() {
    this.dialogRef.close();
  }

  openEditNoteModal() {
    this.dialog
      .open(CreateNoteModalComponent, {
        width: '600px',
        data: { resident: this.data.resident },
        autoFocus: false,
      })
      .afterClosed()
      .subscribe(() => {
        this.closeDialog();
      });
  }
}
